const translations = {
    field: 'Field',
    fieldIsRequired: 'Field is required'
};

export default translations;
